var exports = {
  "kL": "xfb577c5e--274125--container",
  "pq": "xfb577c5e--274125--info",
  "x6": "xfb577c5e--274125--button",
};

module.exports = exports;
